import { render, staticRenderFns } from "./create-order.vue?vue&type=template&id=e7341ae4&scoped=true&"
import script from "./create-order.vue?vue&type=script&lang=js&"
export * from "./create-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7341ae4",
  null
  
)

export default component.exports